import { RouteNames } from '@/router/routeNames';
import useAuthStore from '@/stores/useAuthStore';
import type { NavigationGuard, NavigationGuardReturn } from 'vue-router';

const adminGuard = (): NavigationGuard => async (): Promise<NavigationGuardReturn> => {
    const authStore = useAuthStore();

    await authStore.loadUserRole();

    return authStore.isAdmin ? true : { name: RouteNames.Index };
};

export default adminGuard;
